module.exports = __webpack_public_path__ + "7324e49a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/button_arrowdown@2x.png
// module id = 1023
// module chunks = 0